import {
  browserRandomInteger,
  type RandomIntegerSource,
} from '@/shared/random-integer'

export const MAX_COIN_FLIPS = 100

export type CoinSide = 'heads' | 'tails'
export type CoinFlipValidationError = 'empty_quantity' | 'invalid_quantity'
export type CoinFlipError = CoinFlipValidationError | 'processing_failed'
export type CoinFlipValidation =
  | { status: 'ready'; quantity: number }
  | { status: 'error'; error: CoinFlipValidationError }
export type CoinFlipResult =
  | { status: 'success'; sequence: CoinSide[]; heads: number; tails: number }
  | { status: 'error'; error: CoinFlipError }

export function validateCoinFlipQuantity(quantityInput: string): CoinFlipValidation {
  const normalized = quantityInput.trim()
  if (normalized === '') return { status: 'error', error: 'empty_quantity' }
  if (!/^\d+$/.test(normalized)) return { status: 'error', error: 'invalid_quantity' }

  const quantity = Number(normalized)
  if (!Number.isSafeInteger(quantity) || quantity < 1 || quantity > MAX_COIN_FLIPS) {
    return { status: 'error', error: 'invalid_quantity' }
  }

  return { status: 'ready', quantity }
}

export function flipCoins(
  quantityInput: string,
  randomInteger: RandomIntegerSource = browserRandomInteger,
): CoinFlipResult {
  const validation = validateCoinFlipQuantity(quantityInput)
  if (validation.status === 'error') return validation

  try {
    const sequence = Array.from({ length: validation.quantity }, (): CoinSide => (
      randomInteger(2) === 0 ? 'heads' : 'tails'
    ))
    const heads = sequence.filter((side) => side === 'heads').length

    return { status: 'success', sequence, heads, tails: validation.quantity - heads }
  } catch {
    return { status: 'error', error: 'processing_failed' }
  }
}
